// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.overlay {\n  background-color: var(--bluey-grey-50) !important;\n}\n.dropdown {\n  border: 1px solid var(--bluey-grey) !important;\n}\n.dropdown-item:hover {\n  color: #151515 !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
